import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { FaRegCalendarAlt } from "react-icons/fa";
import { Link } from 'react-router-dom';
import { BASE_URL, USER_URL } from '../../constant/api';

function SubAdminSeller() {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await USER_URL.get(`/accounts/subadmin/companies/`);
        console.log(response);
        
        if (response.data?.data && response.data.data.length > 0) {
          setProducts(response.data.data);
        } else {
          setProducts([{ name: "No Data Available" }]);
        }
      } catch (error) {
        console.error("Error fetching products:", error.message || error);
        setProducts([{ name: "No Data Available" }]);
      }
    };
    fetchProducts();
  }, []);

  return (
    <div className="container mx-auto">
      <div className="overflow-x-auto mt-4">
        <table className="w-full text-left">
          <thead>
            <tr>
              <th className=" text-green-500 text-sm font-bold">Company Name</th>
              {/* <th className="p-2 text-green-500 text-sm font-bold">Seller ID</th> */}
              <th className="p-2 text-green-500 text-sm font-bold">Location</th>
              <th className="p-2 text-green-500 text-sm font-bold">Brand</th>
              <th className="p-2 text-green-500 text-sm font-bold">Join Date</th>
              <th className="p-2 text-green-500 text-sm font-bold">Status</th>
              <th className="p-2 text-green-500 text-sm font-bold">Sub Admin</th>
              <th className="p-2"></th>
            </tr>
          </thead>
          <tbody>
            {products.map((product, index) => (
              <tr key={index}>
                <td>
                  <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm flex items-center gap-2">
                    {product.name || "No Data Available"}
                  </div>
                </td>
                {/* <td className="p-2">
                  <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
                    {product.seller_id || "No Data"}
                  </div>
                </td> */}
                <td className="p-2">
                  <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
                    {product.location || "No Data"}
                  </div>
                </td>
                <td className="p-2">
                  <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
                    {product.brand || "No Data"}
                  </div>
                </td>
                <td className="p-2">
                  <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm flex items-center gap-2">
                    {product.date_joined?.slice(0, 10) || "No Data"}
                    <FaRegCalendarAlt className="text-gray-400 text-base" />
                  </div>
                </td>
                <td className="p-2">
                  <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
                    {product.status || "No Data"}
                  </div>
                </td>
                <td className="p-2">
                  <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
                    {product.subAdmin || "No Data"}
                  </div>
                </td>
                <td className="p-2">
                
                    <Link
                      to={`view/${product.company_id}`}
                      className="text-green-600 border border-green-600 rounded-lg px-4 py-2 text-sm font-medium hover:bg-green-100"
                    >
                      VIEW
                    </Link>
                 
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default SubAdminSeller;
